export default __webpack_public_path__ + "static/media/gallery-28.faa974fd.jpg";